import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  addMultipleAutoPaySuccess,
  deleteAutoPaySuccess,
  editAutoPaySuccess
} from '@amfam/billing/auto-pay/data-access/lib/+state/auto-pay.actions';
import {
  PaymentAccountsAddSuccess,
  PaymentAccountsDeleteSuccess,
  PaymentAccountsEditSuccess
} from '@amfam/billing/paymentaccount/data-access/lib/+state/paymentaccount.actions';
import {
  scheduledPaymentsDeleteSuccess,
  scheduledPaymentsEditSuccess,
  scheduledPaymentsSubmitSuccess
} from '@amfam/billing/schedulepayment/data-access/lib/+state/schedulepayment.actions';

import {
  PaymentConfirmationLoad,
  PaymentConfirmationLoadFail,
  PaymentConfirmationLoadSuccess
} from './paymentConfirmation.actions';

export const loadEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(PaymentConfirmationLoad),
      map(action => action),
      map(confirmationPayload => PaymentConfirmationLoadSuccess(confirmationPayload.payload)),
      catchError(error => of(PaymentConfirmationLoadFail(error)))
    );
  },
  { functional: true }
);

export const multipleAutopaySubmitSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(addMultipleAutoPaySuccess),
      map(action => action),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);

export const autopayEditSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(editAutoPaySuccess),
      map(action => action),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);

export const autopayDeleteSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(deleteAutoPaySuccess),
      map(action => action),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);

export const paymentSubmitSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(scheduledPaymentsSubmitSuccess),
      map(action => action.payload),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);

export const paymentEditSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(scheduledPaymentsEditSuccess),
      map(action => action.payload),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);

export const paymentDeleteSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(scheduledPaymentsDeleteSuccess),
      map(action => action.payload),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);

export const paymentAccountAddSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(PaymentAccountsAddSuccess),
      map(action => action.payload),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);

export const paymentAccountEditSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(PaymentAccountsEditSuccess),
      map(action => action.payload),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);

export const paymentAccountDeleteSuccessEffect = createEffect(
  (action$ = inject(Actions)) => {
    return action$.pipe(
      ofType(PaymentAccountsDeleteSuccess),
      map(action => action.payload),
      map(payload => PaymentConfirmationLoad(payload.confirmation))
    );
  },
  { functional: true }
);
